var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('aside', {
    attrs: {
      "id": "capustaSlider"
    },
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.CLOSE_TRANSACTION($event);
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.slideName,
      "mode": "out-in"
    }
  }, [_c('TransactionInfo', {
    directives: [{
      name: "hammer",
      rawName: "v-hammer:pan",
      value: _vm.onSwipe,
      expression: "onSwipe",
      arg: "pan"
    }],
    key: _vm.SELECTED_TRANSACTION.owner_id,
    attrs: {
      "transaction": _vm.SELECTED_TRANSACTION
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }